module.exports = __webpack_public_path__ + "static/mircom-logo-6828cda13c5bb27ac346231a4e48385e.jpg";